const HEADER_MIN_WIDTH = 200;

export const columns = [
  {
    field: 'users',
    headerName: 'Users',
    apiName: 'UserName',
    flex: 1,
    minWidth: HEADER_MIN_WIDTH,
    isVisible: true,
    index: 0,
  },
  {
    field: 'docID',
    headerName: 'Doc ID',
    apiName: 'DocumentID',
    flex: 1,
    minWidth: HEADER_MIN_WIDTH,
    isVisible: true,
    index: 1,
  },
  {
    field: 'action',
    headerName: 'Action',
    apiName: 'ActionName',
    flex: 1,
    minWidth: HEADER_MIN_WIDTH,
    isVisible: true,
    index: 2,
  },
  {
    field: 'actionOn',
    headerName: 'Action On',
    apiName: 'ActionOn',
    flex: 1,
    minWidth: HEADER_MIN_WIDTH,
    isVisible: true,
    index: 3,
  },
  {
    field: 'locationOfUser',
    headerName: 'Location Of User',
    apiName: 'UserLocation',
    flex: 1,
    minWidth: HEADER_MIN_WIDTH,
    isVisible: true,
    index: 4,
  },
  {
    field: 'dateTime',
    headerName: 'Date/Time (UTC)',
    apiName: 'DocumentDateTime',
    flex: 1,
    minWidth: HEADER_MIN_WIDTH,
    isVisible: true,
    index: 5,
  },
];
